var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoKarada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 16,
    viewBox: "0 0 88 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 19,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sp19-karada-brand-story",
    transform: "translate(-116 -1256)",
    fill: "#1E1E20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0 568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0 504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(116 96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text-karada",
    transform: "translate(0 88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.844.31C9.037.138 9.309 0 9.6 0c.543 0 1.066.485 1.066 1.047 0 .156-.018.602-.407.95L4.674 7.08c.465.077 1.028.214 1.861 1.377l4.17 5.78c.117.155.175.446.175.66 0 .62-.466 1.104-.97 1.104-.388 0-.853-.213-1.086-.562L4.829 9.737C4.111 8.708 3.452 8.65 2.987 8.63l-.777.718v5.565c0 .738-.6 1.067-1.124 1.067-.679 0-1.086-.484-1.086-1.047V1.145C0 .465.523 0 1.144 0 1.92 0 2.21.776 2.21 1.145v5.236L8.844.311Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.344 9.581 19.9 2.425 17.437 9.58l-.737 2.153-1.163 3.394c-.04.116-.33.873-1.067.873-1.183 0-1.222-1.01-1.222-1.145 0-.175.039-.31.097-.484l4.733-12.976C18.504.233 19.202.001 19.958.001c.33 0 1.242 0 1.746 1.395l4.751 12.976c.039.117.097.31.097.523 0 .66-.504 1.086-1.202 1.086-.562 0-.931-.35-1.105-.853l-1.164-3.394-.737-2.153Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.56 9.581-2.444-7.156-2.463 7.156-.738 2.153-1.163 3.394c-.04.116-.329.873-1.067.873-1.183 0-1.221-1.01-1.221-1.145 0-.175.038-.31.097-.484l4.732-12.976C49.72.233 50.418.001 51.174.001c.33 0 1.241 0 1.746 1.395l4.75 12.976c.04.117.098.31.098.523 0 .66-.505 1.086-1.203 1.086-.562 0-.93-.35-1.105-.853l-1.164-3.394-.736-2.153Z",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.86 6.886c1.183 0 2.618-.33 2.618-2.154 0-1.531-.989-2.25-2.462-2.25h-4.21c-.464 0-.853.059-.853.738v3.666h4.907Zm-4.907 8.028c0 .718-.582 1.067-1.125 1.067-.833 0-1.085-.66-1.085-1.047V2.502c0-1.358.6-2.152 2.074-2.152h5.49c2.966 0 4.46 2.036 4.46 4.344 0 1.203-.407 2.424-1.338 3.239-.854.737-1.649.853-2.308.95.562.35.97.776 1.299 1.319l2.385 3.937c.234.388.272.678.272.815 0 .465-.387 1.046-1.105 1.046-.582 0-.854-.212-1.106-.659L38.043 12.2c-.969-1.687-1.842-3.18-3.16-3.18h-2.93v5.895Z",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.337 9.581-2.444-7.156L78.43 9.58l-.736 2.153-1.163 3.394c-.04.116-.33.873-1.067.873-1.183 0-1.222-1.01-1.222-1.145 0-.175.039-.31.097-.484L79.07 1.396C79.497.233 80.195.001 80.951.001c.33 0 1.242 0 1.746 1.395l4.751 12.976c.039.117.097.31.097.523 0 .66-.504 1.086-1.203 1.086-.561 0-.93-.35-1.104-.853l-1.164-3.394-.737-2.153Z",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.86 12.723c0 .135 0 .66.64.66h2.521c3.278 0 4.306-2.929 4.306-5.392 0-2.58-.815-5.411-4.79-5.411H63.79c-.854 0-.93.446-.93 1.009v9.134Zm-.369 2.91c-1.338 0-1.861-.777-1.861-2.096V2.347c0-1.222.717-1.997 1.843-1.997h3.703c4.073 0 6.458 3.277 6.458 7.68 0 4.053-2.133 7.603-6.089 7.603h-4.054Z",
    id: "Fill-15"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKarada);
export default __webpack_public_path__ + "static/media/logo-karada.0e664983.svg";
export { ForwardRef as ReactComponent };